"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TranslateAware = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _selectors = require("../../store/locale/selectors");

var _selectors2 = require("../../store/messages/selectors");

var _config = require("../../config");

var _TranslationContext = require("./TranslationContext");

var _translation = require("../../constants/translation");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TranslateAware = function TranslateAware(WrappedComponent) {
  var translationPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _translation.SKIP_TRANSLATION_CONTEXT;

  var LangAware =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(LangAware, _React$Component);

    function LangAware() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, LangAware);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LangAware)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "resolve", function (o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1');
        s = s.replace(/^\./, '');
        var a = s.split('.');

        for (var i = 0, n = a.length; i < n; ++i) {
          var k = a[i];

          if (o === undefined) {
            return;
          }

          if (k in o) {
            o = o[k];
          } else {
            return;
          }
        }

        return o;
      });

      _defineProperty(_assertThisInitialized(_this), "isClassificationLib", function (key) {
        return key.match(/LIB\.\d{7}\.\d{3}\.\d{7}\.\d{3}/) != null;
      });

      _defineProperty(_assertThisInitialized(_this), "isTranslationKey", function (key) {
        return key.match(/(\w+\/\w+)+/) != null;
      });

      _defineProperty(_assertThisInitialized(_this), "translate", function (key, defaultMessage, context) {
        // Check input arguments arguments
        try {
          if (key === undefined) {
            throw new Error("Translation key must be set!");
          }

          if (typeof key !== "string") {
            throw new Error("Translation key must be a string!");
          }
        } catch (e) {
          console.warn(e.messages, e.stack);
        }

        if (key == null) return;
        var ketParts = []; // Local component prefix

        if (context && context.translationPrefix) {
          ketParts.push(context.translationPrefix);
        }

        ketParts.push(key);
        var localKey = ketParts.join("/");

        if (!_this.isTranslationKey(localKey) && !_this.isClassificationLib(key)) {
          return key;
        }

        var isLib = _this.isClassificationLib(key);

        var fullKey = isLib ? key : _config.Config.get('settings', 'translationPrefix') + "/" + localKey;
        var message = isLib ? _this.props.messages[key] : _this.resolve(_this.props.messages, fullKey);

        if (!message && defaultMessage) {
          return defaultMessage;
        }

        if (!message) {
          if (_this.props.locale === _translation.DEBUG_LOCALE) {
            return fullKey;
          } else {
            if (process.env.NODE_ENV !== 'production') {
              // Shorter key for developer copy paste keys to translation file
              if (key && localKey && localKey.split("/").length > 1) {
                var lastValue = localKey.split("/").slice(-1).pop(); // console.log(localKey, "=", _.capitalize(_.startCase(lastValue).toLowerCase()));
              }
            }

            return localKey;
          }
        }

        return message;
      });

      return _this;
    }

    _createClass(LangAware, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        if (translationPrefix === _translation.USE_TRANSLATION_CONTEXT) {
          return _react["default"].createElement(_TranslationContext.TranslationContext.Consumer, null, function (translationContext) {
            return _react["default"].createElement(WrappedComponent, _extends({}, _this2.props, {
              translate: function translate(key, defaultMessage) {
                return _this2.translate(key, defaultMessage, translationContext);
              }
            }));
          });
        } else if (translationPrefix && translationPrefix !== _translation.SKIP_TRANSLATION_CONTEXT) {
          return _react["default"].createElement(_TranslationContext.TranslationContext.Provider, {
            value: {
              translationPrefix: translationPrefix
            }
          }, _react["default"].createElement(_TranslationContext.TranslationContext.Consumer, null, function (translationContext) {
            return _react["default"].createElement(WrappedComponent, _extends({}, _this2.props, {
              translate: function translate(key, defaultMessage) {
                return _this2.translate(key, defaultMessage, translationContext);
              }
            }));
          }));
        } else {
          //
          return _react["default"].createElement(WrappedComponent, _extends({}, this.props, {
            translate: this.translate
          }));
        }
      }
    }]);

    return LangAware;
  }(_react["default"].Component);

  _defineProperty(LangAware, "contextType", _TranslationContext.TranslationContext);

  LangAware.contextType = _TranslationContext.TranslationContext;

  var mapStateToProps = function mapStateToProps(state) {
    return {
      locale: (0, _selectors.getLocale)(state),
      messages: (0, _selectors2.getMessages)(state)
    };
  };

  var mapDispatchToProps = {};
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LangAware);
};

exports.TranslateAware = TranslateAware;
var _default = TranslateAware;
exports["default"] = _default;